import { api } from "@/api";
import { UpdateBettingSelectionParams, BettingSelectionDto } from "@/types/ApiResponses/BettingSelection";

export const updateBettingSelection = async (
  params: UpdateBettingSelectionParams
): Promise<BettingSelectionDto> => {
  const { id, ...body } = params;
  const res = await api.client.patch(`/betting-selections-new/${id}`, body);
  return res.data;
};
